export default "__VITE_ASSET__BU3gZ6ql__"